// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"StickyHeader_placeholder__do6Bw"};